namespace Matrix.Workflow {
    export namespace RunBookService {
        export const baseUrl = 'Workflow/RunBook';

        export declare function Create(request: Serenity.SaveRequest<RunBookRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<RunBookRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<RunBookRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<RunBookRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListDependencies(request: Administration.RunBookListRequest, onSuccess?: (response: Serenity.ListResponse<string>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListExisting(request: Administration.RunBookListRequest, onSuccess?: (response: Administration.RunBookListResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Workflow/RunBook/Create",
            Update = "Workflow/RunBook/Update",
            Delete = "Workflow/RunBook/Delete",
            Retrieve = "Workflow/RunBook/Retrieve",
            List = "Workflow/RunBook/List",
            ListDependencies = "Workflow/RunBook/ListDependencies",
            ListExisting = "Workflow/RunBook/ListExisting"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ListDependencies', 
            'ListExisting'
        ].forEach(x => {
            (<any>RunBookService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
